import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { exhaustMap, map, tap } from 'rxjs';
import { OfferService } from 'src/app/shared/services/offers/offers.service';

import * as OfferActions from '../actions/offer.actions';

@Injectable()
export class OfferEffects {
  private readonly actions$ = inject(Actions);
  private readonly offerService = inject(OfferService);
  private readonly router = inject(Router);

  sendManureOffer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfferActions.sendManureOffer),
      exhaustMap((action) =>
        this.offerService.postRequest(action.request).pipe(
          map((response) => OfferActions.sendManureOfferSuccess({ response })),
          tap(() => {
            this.router.navigate(['offer/confirmation']);
          }),
        ),
      ),
    ),
  );
}
